/*global _, $ */
const MENU_PARENT_LINK_CLASS = 'funzone-rewards-parent-link'
let MOBILE_HEADER_NAV_CONTAINER = '.page-header-compact-container .nav-compact-buttons'
let MOBILE_HEADER_NAV_CLOSE_BUTTON = '.page-header-compact-container .nav-compact-buttons .off-canvas-trigger.open'

const funZoneRewardsNavContainers = [
  '.page-header-full nav .container > ol > li > a',
  '.off-canvas-nav .off-canvas-nav-container > ol > li > a'
].join(',')

const funZoneMenuItems = [
  "login", "view", "loyalty", "rewards", "support", "logout"
]
const funZoneRewardsNavUrl = '/funzone-rewards'
const funZoneRewardsAuthUrl = '/profile#loyalty'

const menuGen = {
  logout(instance) {
    return {
      key: 'logout',
      title: instance.logoutLabel,
      onClick: async (e) => {
        e.preventDefault()
        await instance.initLogout()
      }
    }
  },
  login(instance) {
    const loginLabel = instance.$$t('site.nav.login.label', instance.$$s('site.nav.login.label', 'Sign in'))
    return {
      key: 'login',
      title: loginLabel,
      url: instance.getRouteUrl('sign-in')
    }
  }
}

const getNavContainerItems = (instance) => {
  const navContainer = instance.$$s('site.nav.funZoneRewards.selector', funZoneRewardsNavContainers)
  const navUrl = instance.$$s('site.nav.funZoneRewards.url', funZoneRewardsNavUrl)
  const authUrl = instance.$$s('site.nav.funZoneRewards.authUrl', funZoneRewardsAuthUrl)

  const desktopNavParent = instance.$$s('site.nav.funZoneRewards.desktopMenuParent', '.page-header-full')
  const mobileNavParent = instance.$$s('site.nav.funZoneRewards.mobileMenuParent', '.off-canvas-nav')
  MOBILE_HEADER_NAV_CONTAINER = instance.$$s('site.nav.funZoneRewards.mobileHeaderNavParent', MOBILE_HEADER_NAV_CONTAINER)
  MOBILE_HEADER_NAV_CLOSE_BUTTON = instance.$$s('site.nav.funZoneRewards.mobileHeaderCloseButton', MOBILE_HEADER_NAV_CLOSE_BUTTON)

  const definedContainers = $(navContainer)
  const items = _.filter(definedContainers, item => {
    const elm = $(item)
    const url = elm.attr('href')
    const isNav = _.endsWith(url, navUrl)
    if (isNav) {
      elm.data('originalUrl', url)
      elm.data('authUrl', authUrl)
      elm.addClass(MENU_PARENT_LINK_CLASS)
    }
    return isNav
  })

  const containers = items.map(i => $(i).parent())

  // find desktop menu's parent container
  const desktopParent = _.reduce(containers, (target, item) => {
    if (item.closest(desktopNavParent).length) {
      item.attr('data-desktop-menu', 1)
      return item
    }
    return target
  }, null)

  // hide the re-login-status component
  if (desktopParent && desktopParent.length) {
    const instanceContainer = $(instance.$el).parent()
    instanceContainer.detach().appendTo(desktopParent)
    instanceContainer.hide()
  }

  // find mobile menu's parent container
  const mobileParent = _.reduce(containers, (target, item) => {
    if (item.closest(mobileNavParent).length) {
      item.attr('data-mobile-menu', 1)
      return item
    }
    return target
  }, null)

  // additional button to toggle menu in mobile view
  if (mobileParent && mobileParent.length) {
    const mobileExpandButton = $('<button class="is-vishidden"><span class="vishidden">show submenu</span></button>')
    mobileExpandButton.appendTo(mobileParent)
    mobileExpandButton.click(() => {
      mobileParent.toggleClass('open')
    })
  }

  return containers
}

const getMenuItems = (instance) => {
  const profileKeys = instance.$$s('site.nav.funZoneRewards.profileKeys', funZoneMenuItems)

  const menuDefs = _.keyBy(_.cloneDeep(instance.menu), 'key')
  return _.filter(_.map(profileKeys, key => {
    const menu = menuDefs[key] || menuGen[key](instance)
    if (_.isObject(menu) && !menu.url && !menu.onClick) {
      menu.url = instance.getProfileLink(menu.key)
    }
    return menu
  }))
}

const handleSelectedMenu = (instance, navItems) => {
  // set active menu based on selected item
  // works only in profile page and for the items visible in the menu
  instance.$watch('selected', selected => {
    if (!selected) {
      return
    }
    _.forOwn(navItems, parent => {
      const dropdown = parent.find('.funZoneProfileNav')
      const menuItems = dropdown.find('li')
      _.forOwn(menuItems, menuItem => {
        const elm = $(menuItem)
        elm.removeClass('active')
        elm.find('a').removeClass('active')
        if (elm.hasClass(`profile-menu-${selected}`)) {
          elm.addClass('active')
          elm.find('a').addClass('active')
        }
      })
    })
  }, {immediate: true})
}

const switchParentLink = (parent, isAuthenticated) => {
  const parentMenu = parent.find('a.' + MENU_PARENT_LINK_CLASS)
  if (parentMenu.length) {
    const elm = $(parentMenu)
    const originalUrl = elm.data('originalUrl')
    const authUrl = elm.data('authUrl')
    const url = isAuthenticated ? authUrl : originalUrl
    elm.attr('href', url)
    elm.off('click.hideMenu').on('click.hideMenu', (e) => {
      const changed = mayExpandMobileMenu(e)
      if (!changed) {
        hideMobileMenu(e)
      }
    })
  }
}

const handleAuth = (instance, navItems) => {
  // hide or show menu based on authenticated state
  instance.$watch('authenticated', (isAuthenticated) => {
    _.forOwn(navItems, parent => {
      switchParentLink(parent, isAuthenticated)
      const dropdown = parent.find('.funZoneProfileNav')
      const menuItems = dropdown.find('li:not(.profile-menu-login)')
      const login = dropdown.find('li.profile-menu-login')

      // hide or show all menu item except logout
      // hide for not authenticated
      // show for authenticated
      _.forOwn(menuItems, menuItem => {
        const $menuItem = $(menuItem)
        if (isAuthenticated) {
          $menuItem.show()
        } else {
          $menuItem.hide()
        }
      })

      // for not-authenticated - hide logout, show login
      // for authenticated - show logout, hide login
      if (isAuthenticated) {
        login.hide()
      } else {
        login.show()
      }
      // hack fix to issue where tht dropdown is being visible all the time for authenticated case
      dropdown.css('display', '')
    })

  }, {immediate: true})
}

const hideMobileMenu = (e) => {
  const isMobile = $(e.target).closest('[data-mobile-menu=1]').length
  if (isMobile) {
    const closeButton = $(MOBILE_HEADER_NAV_CLOSE_BUTTON)
    closeButton[0].click()
  }
}

const mayExpandMobileMenu = (e) => {
  const elm = $(e.target)
  const parent = elm.closest('[data-mobile-menu=1]')
  const isMobile = parent.length
  if (isMobile) {
    if (window.location.href.includes(elm.attr('href'))) {
      const expandButton = parent.find('.is-vishidden')
      if (expandButton) {
        expandButton.click()
        return true
      }
    }
  }
}

export const renderFunZoneRewardsMenu = (instance) => {
  const menuItems = getMenuItems(instance)
  const navItems = getNavContainerItems(instance)
  if (!navItems.length) {
    return
  }

  // generate nav dropdown menu
  _.forOwn(navItems, parent => {
    let dropdown = parent.find('ol.funZoneProfileNav')
    if (!dropdown.length) {
      dropdown = $('<ol class="funZoneProfileNav"></ol>')
      _.forOwn(menuItems, item => {
        const key = item.key
        const menu = $(`<li class="nav-item--level-2 profile-menu-${key}"></li>`)
        const link = $(`<a class="profile-menu-link-${key}"></a>`)
        link.text(item.title + ' ')
        link.attr('href', item.url || '#')
        if (item.onClick) {
          link.off('click').on('click', item.onClick)
        } else {
          link.off('click.hideMenu').on('click.hideMenu', hideMobileMenu)
        }
        link.appendTo(menu)
        menu.appendTo(dropdown)
      })
      dropdown.appendTo(parent)
    }
  })

  handleSelectedMenu(instance, navItems)
  handleAuth(instance, navItems)
}

export default renderFunZoneRewardsMenu
